import { LangEum } from '@/constant'
import { createContext } from 'react'

const enLang = {
  discount: 'Welcome Offer',
}
const jaLang = {
  discount: '新規割引価格',
}

const zhTWLang = {
  discount: '新人折扣價',
}
const zhLang = {
  discount: '新人折扣价',
}

export type LangType = typeof enLang

export const langMap = {
  [LangEum.en]: enLang,
  [LangEum['zh-TW']]: zhTWLang,
  [LangEum['zh-TW2']]: zhTWLang,
  [LangEum['zh-MO']]: zhTWLang,
  [LangEum.ja]: jaLang,
  [LangEum.zh]: zhLang,
  [LangEum['zh-SG']]: zhLang,
  [LangEum['zh-MY']]: zhLang,
}

const context = createContext({
  currencyCode: 'HK$',
  lang: LangEum.en,
  langConfig: langMap.en,
})


export default context
